/**
 * FarmPacks: hand a won prize to the shopper's basket.
 *
 * Used by the Spin the Wheel page and the popup wheel. Given a prize it
 *   - applies the discount code, by visiting Shopify's /discount/<code> link,
 *     which keeps it for checkout (it shows there, not on the basket page), and
 *   - for a prize that is a product (the free Complete Kit), adds one to the
 *     basket, unless one is already in it, then tells the theme so the basket
 *     icon and drawer update.
 *
 * Nothing here can fail loudly: if a step does not work the result says so and
 * the panel falls back to "copy your code".
 */
(function () {
  if (window.FpWheelPrize) return;

  var json = function (response) {
    return response.json();
  };

  // Let the theme's basket icon and drawer know the basket changed.
  var announce = async function (variant) {
    try {
      var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(json);
      var events = await import('@shopify/events');
      var line = (cart.items || []).find(function (item) {
        return item.variant_id === variant;
      });
      var deferred = events.CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(
        new events.CartLinesUpdateEvent({
          action: 'update',
          context: 'cart',
          lines: [{ id: line ? line.key : '', quantity: line ? line.quantity : 1 }],
          promise: deferred.promise,
        })
      );
      deferred.resolve({
        cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { itemCount: cart.item_count, items: cart.items, source: 'fp-wheel' },
      });
    } catch (error) { /* the basket will be right on the next page load */ }
  };

  var applyCode = async function (code) {
    try {
      var response = await fetch('/discount/' + encodeURIComponent(code), {
        credentials: 'same-origin',
        redirect: 'manual',
      });
      return response.type === 'opaqueredirect' || response.ok;
    } catch (error) {
      return false;
    }
  };

  var addItem = async function (variant, allowAdd) {
    try {
      var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(json);
      var has = (cart.items || []).some(function (item) {
        return item.variant_id === variant;
      });
      if (has) return 'already';
      if (!allowAdd) return '';
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: variant, quantity: 1 }] }),
      });
      if (!response.ok) return '';
      await announce(variant);
      return 'added';
    } catch (error) {
      return '';
    }
  };

  window.FpWheelPrize = {
    /**
     * @param {{code: string, variant?: number}} prize
     * @param {{addItem?: boolean}} [options] addItem false never adds: it only
     *   refreshes the code and reports whether the product is already in the basket.
     * @returns {Promise<{code: boolean, item: '' | 'added' | 'already'}>}
     */
    apply: async function (prize, options) {
      var result = { code: await applyCode(prize.code), item: '' };
      if (prize.variant) {
        result.item = await addItem(prize.variant, !(options && options.addItem === false));
      }
      return result;
    },

    /** Say what happened, in the panel's status line. */
    describe: function (panel, prize, result) {
      var line = panel && panel.querySelector('[data-fp-applied]');
      if (!line) return;
      var text = line.querySelector('[data-fp-applied-text]');
      var basket = line.querySelector('[data-fp-applied-link]');
      var message;
      if (result.item === 'added' || result.item === 'already') {
        message = result.code
          ? 'Your free Complete Kit is in your basket and your code is applied. The discount shows at checkout.'
          : 'Your free Complete Kit is in your basket. Copy your code and enter it at checkout.';
      } else if (result.code) {
        message = 'Your code has been applied to your basket automatically. You will see it at checkout, and you can copy it to use later.';
      } else {
        message = 'Copy your code and enter it at checkout.';
      }
      if (text) text.textContent = message;
      if (basket) basket.hidden = !(result.item === 'added' || result.item === 'already');
      line.classList.toggle('is-ok', result.code || Boolean(result.item));
      line.hidden = false;
    },
  };
})();
